import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import notifications from '../../../../redux/notifications/actions';

const api = new Api('workers/:id/sector_interests');
const sectorInterestApi = new Api('workers/:id/sector_interests/:sector_interest_id');

function* loadData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, api.load, { id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(actions.loadDataSuccess(result.data.success.data));
    }
  } catch (error) {
    console.warn(error);
  }
}

function* loadFormData({ payload }) {
  try {
    const { id } = payload;

    const result = yield call(sendRequest, api.loadFormData, { id }, notifications.REQUEST_ERROR);

    if (result && result.data && result.data.success && result.data.success.data) {
      yield put(actions.loadFormData(result.data.success.data));
    }
  } catch (error) {
    console.warn(error);
  }
}

function* createInterest({ payload }) {
  try {
    const { id, sectorId, positionIds } = payload;

    const result = yield call(
      sendRequest,
      api.createItem,
      { id, data: { sector_interest: { sector_id: sectorId, position_ids: positionIds } } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.loadData({ id }));
    }
  } catch (error) {
    console.warn(error);
  }
}

function* updateInterest({ payload }) {
  try {
    const { id, sectorId, positionIds, sectorInterestId } = payload;

    const result = yield call(
      sendRequest,
      sectorInterestApi.multiparamsUpdateItem,
      {
        params: { id, sector_interest_id: sectorInterestId },
        data: { sector_interest: { sector_id: sectorId, position_ids: positionIds } },
      },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.loadData({ id }));
    }
  } catch (error) {
    console.warn(error);
  }
}

function* deleteInterest({ payload }) {
  try {
    const { id, sectorInterestId } = payload;

    const result = yield call(
      sendRequest,
      sectorInterestApi.multipleParamsDeleteItem,
      { params: { id, sector_interest_id: sectorInterestId } },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.loadData({ id }));
    }
  } catch (error) {
    console.warn(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DELETE_INTEREST_REQUEST, deleteInterest),
    takeEvery(actions.LOAD_REQUEST, loadData),
    takeEvery(actions.LOAD_REQUEST, loadFormData),
    takeEvery(actions.CREATE_INTEREST_REQUEST, createInterest),
    takeEvery(actions.UPDATE_INTEREST_REQUEST, updateInterest),
  ]);
}
